import { apiClient } from './client';
import { AdminTask, AdminTaskType, AdminTaskDetail, PaginatedResponse } from '../../types';

export interface CreateAdminTaskRequest {
  type: AdminTaskType;
  detail: AdminTaskDetail;
}

export const adminTasksApi = {
  getTasks: async (params?: { pageIndex?: number; pageSize?: number; type?: string; status?: string }): Promise<PaginatedResponse<AdminTask>> => {
    return apiClient.get<PaginatedResponse<AdminTask>>('/api/v1/admin/tasks', { params });
  },

  getTaskDetail: async <TDetail = AdminTaskDetail>(id: string): Promise<{ data: AdminTask<TDetail> }> => {
    return apiClient.get<{ data: AdminTask<TDetail> }>(`/api/v1/admin/tasks/${id}`);
  },

  createTask: async (data: CreateAdminTaskRequest): Promise<{ data: AdminTask }> => {
    return apiClient.post<{ data: AdminTask }>('/api/v1/admin/tasks', data);
  },

  restartTask: async (id: string): Promise<{ data: AdminTask }> => {
    return apiClient.post<{ data: AdminTask }>(`/api/v1/admin/tasks/${id}/restart`);
  },

  deleteTask: async (id: string): Promise<{ success: boolean }> => {
    return apiClient.delete<{ success: boolean }>(`/api/v1/admin/tasks/${id}`);
  },
};
